module.exports = __webpack_public_path__ + "img/sqzsIco6.871ff9b8.png";